import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import {Box, keyframes} from "@mui/material";
import {useNavigate} from "react-router-dom";

export default function ProjectCard({imgPath, title, description, ctaUrl, ctaRoute, skills}) {

    const navigate = useNavigate();

    const rotateSkill = keyframes`
        0% { transform: rotate(-2deg); }
        100% { transform: rotate(2deg); }
    `;

    const skillSx = {
        fontSize: "13px",
        padding: "4px 8px",
        backgroundColor: "#f5f5f5",
        textTransform: "uppercase",
        animation: `${rotateSkill} 2.0s linear infinite alternate`,
        margin: "10px",
        width: 'fit-content',
        height: 'fit-content',
        borderRadius: '4px',
        fontStyle: 'italic'
    }

    const onCtaClick = () => {
        if (ctaRoute) {
            navigate(ctaRoute);
        } else if (ctaUrl) {
            window.open(ctaUrl, '_blank', 'noopener,noreferrer');
        }
    }

    const hasLink = ctaRoute || ctaUrl;

    return (
        <Card sx={{
            maxWidth: 345,
            height: '100%',
            justifyContent: 'space-between',
            display: 'flex',
            flexDirection: 'column',
            background: '#fff',
        }}>
            <Box sx={{
                justifyContent: 'start',
                display: 'flex',
                flexDirection: 'column',
            }}>
                <CardMedia
                    component="img"
                    alt={title}
                    height="140"
                    image={imgPath}
                    sx={{ objectFit: "cover", marginTop: '16px' }}
                />
                <CardContent>
                    <Typography gutterBottom variant="h5" component="div" fontWeight={'bold'} textAlign={'center'}>
                        {title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary', paddingBottom: '16px' }} textAlign={'center'}>
                        {description}
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', minHeight: '230px', justifyContent: 'center', alignContent: 'baseline'}}>
                        {skills.map((skill) => (<Typography variant="body2" component={'div'} sx={skillSx}>
                            {skill}
                        </Typography>))}
                    </Box>
                </CardContent>
            </Box>
            <CardActions sx={{display: 'flex', justifyContent: 'center', paddingBottom: '16px'}}>
                <Button size="small" variant={'outlined'} onClick={onCtaClick} disabled={!hasLink} sx={{flexBasis: '90%'}}>
                    {hasLink ? 'View Case Study' : 'No Longer Available'}
                </Button>
            </CardActions>
        </Card>
    );
}